import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import StudentsPaymentList from "../../containers/admin/payment/paymentList";
import StudentPayments from "../../pages/admin/student-payments";
import Chapters from "../../pages/admin/chapters";
import QuestionContainers from "../../pages/admin/question-containers";
import Events from "../../pages/admin/events";
import Exams from "../../pages/admin/exams";
import Groups from "../../pages/admin/groups";
import Homeworks from "../../pages/admin/homework";
import Lectures from "../../pages/admin/lectures";
import Lessons from "../../pages/admin/lessons";
import Payment from "../../pages/admin/payment";
import QuestionsBank from "../../pages/admin/questions-bank";
import TagMissedQuestions from "../../pages/admin/tag-missed-questions";
import Tags from "../../pages/admin/tags";
import RedoRequests from "../../pages/admin/redo-requests";
import AttendanceReport from "../../pages/admin/reports/attendance";
import DownloadableReport from "../../pages/admin/reports/downloadable-report";
import ExamReport from "../../pages/admin/reports/exam";
import DetailedExamReport from "../../pages/admin/reports/detailed-exam-report";
import ExamAttendanceReport from "../../pages/admin/reports/exam-attendance";
import GroupsReport from "../../pages/admin/reports/groups";
import HomeworkAbsentReport from "../../pages/admin/reports/homework-absent";
import HomeworkAttendanceReport from "../../pages/admin/reports/homework-attendence";
import HomeworkUncommentReport from "../../pages/admin/reports/homework-uncomment";
import PrintableQuestions from "../../pages/admin/reports/printable-questions";
import UnpaiedReport from "../../pages/admin/reports/unpaid-report";
import PaymentReport from "../../pages/admin/reports/payment-report";
import VideoReport from "../../pages/admin/reports/video-views";
import ScanCode from "../../pages/admin/scan-code";
import Sections from "../../pages/admin/sections";
import PaymentSubject from "../../pages/admin/paymentSubject";
import Streaming from "../../pages/admin/streaming";
import StudentExamsList from "../../pages/admin/student-exams/index";
import StudentExamsMain from "../../pages/admin/student-exams-main";
import Students from "../../pages/admin/students";
import StudentsBySubject from "../../pages/admin/students-by-subject";
import InactiveStudents from "../../pages/admin/inactive-students";
import Teachers from "../../pages/admin/teachers";
import TeachersAssistant from "../../pages/admin/teachersAssistant";
import Videos from "../../pages/admin/videos";
import VideosMoreViewRequests from "../../pages/admin/videosMoreViewRequests";
import Views from "../../pages/admin/views";
import Home from "../../pages/public/home";
import AsqueraPracticeExams from "../../pages/student/asqueraPractise/exams-list";
import AsqueraPracticeSolveExam from "../../pages/student/asqueraPractise/solve-exam";
import VideoPreviewPage from "../../pages/student/asqueraPractise/videoPreview";
import ChapterExams from "../../pages/student/exams/chapter-exams";
import ChaptersExamsList from "../../pages/student/exams/chapters-list";
import ExamResult from "../../pages/student/exams/exam-result";
import ExameGuide from "../../pages/student/exams/exame-guide";
import ExamsSectionsList from "../../pages/student/exams/sections-list";
import SolveExam from "../../pages/student/exams/solve-exam";
import StudentHome from "../../pages/student/home";
import StudentCourses from "../../pages/student/courses";
import StudentCourseDetails from "../../pages/student/courses/course-details";
import StudentQuickLinks from "../../pages/student/quick-links";
import StudentOfficeHoursPage from "../../pages/student/office-hours";
import StudentPerformanceAnalytics from "../../pages/student/performance-analytics";
import StudentExamsPage from "../../pages/student/student-exams";
import StudentHomeWork from "../../pages/student/homework";
import HomeworkChaptersList from "../../pages/student/homework/chapters-list";
import HomeworkSectionsList from "../../pages/student/homework/sections-list";
import StudentModelAnswer from "../../pages/student/model-answer";
import ModelAnswersChaptersList from "../../pages/student/model-answer/chapters-list";
import Questions from "../../pages/student/questions";
import StudentVideo from "../../pages/student/videos";
import VideosChaptersList from "../../pages/student/videos/chapters-list";
import QrCodeVideos from "../../pages/student/videos/qrcode-videos";
import SectionsList from "../../pages/student/videos/sections-list";
import TeacherTemplate from "../../pages/teachers/teacher-template";
import LoginForm from "../Auth/LoginForm";
import RequireAuth from "../Auth/ProtectedRouter";
import SignupForm from "../Auth/SignupForm";
import OtpForm from "../Auth/OtpForm";
import LiveVideos from "../../pages/admin/liveVideos";
import LiveVideosReport from "../../pages/admin/reports/livevideos-report";
import LiveVideoAttendanceReport from "../../pages/admin/reports/live-video-attendance-report";
import StudentPerformanceReport from "../../pages/student/performance-report";
import VideoAbsenceReport from "../../pages/admin/reports/video-absence";
import BulkCustomMessage from "../../pages/admin/reports/bulk-message";
import HomeworkReportByChapter from "../../pages/admin/reports/homework-report-by-chapter";
import AttendanceSimpleReport from "../../pages/admin/reports/attendance-simple";
import AbsentReport from "../../pages/admin/reports/absent-report";
import ManualExamMarksReport from "../../pages/admin/reports/manual-exam-marks";
import SavedMessages from "../../pages/admin/saved-messages";
import SavedMessagesByPhone from "../../pages/admin/saved-messages-by-phone";
import Announcements from "../../pages/admin/announcements";
import CustomNotifyPractice from "../../pages/admin/custom-notify-practice";
import SubjectAssistPhones from "../../pages/admin/subject-assist-phones";
import OfficeHours from "../../pages/admin/office-hours";
import Assistants from "../../pages/admin/assistants";
import TelegramActiveUsers from "../../pages/admin/reports/telegram-active-users";
import TelegramInactiveUsers from "../../pages/admin/reports/telegram-inactive-users";
import CorrectStudentExams from "../../pages/admin/correct-student-exams";
import ComingSoon from "../../pages/public/ComingSoon";
import NotFound from "../../pages/public/NotFound";

const Routers = () => {
  return (
    <Routes>
      {/* public */}
      <Route path="/" element={<ComingSoon />} />

      {/* auth */}
      <Route path="/login" element={<LoginForm />} />
      <Route path="/signup" element={<SignupForm />} />
      <Route path="/otp" element={<OtpForm />} />

      {/* teacher/public template (keep protected unless you want otherwise) */}
      <Route
        path="/teacher/:name"
        element={(
          <RequireAuth>
            <TeacherTemplate />
          </RequireAuth>
        )}
      />

      {/* dashboard (protected) */}
      <Route
        path="/dashboard/sections"
        element={(
          <RequireAuth>
            <Sections />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/students"
        element={(
          <RequireAuth>
            <Students />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/students-by-subject"
        element={(
          <RequireAuth>
            <StudentsBySubject />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/inactive-students"
        element={(
          <RequireAuth>
            <InactiveStudents />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/groups"
        element={(
          <RequireAuth>
            <Groups />
          </RequireAuth>
        )}
      />

      {/* <ProtectedRouter
        path="/dashboard/centers"
        element={<Centers />}
      ></ProtectedRouter> */}

      <Route
        path="/dashboard/lessons"
        element={(
          <RequireAuth>
            <Lessons />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/streaming"
        element={(
          <RequireAuth>
            <Streaming />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/videos"
        element={(
          <RequireAuth>
            <Videos />
          </RequireAuth>
        )}
      />

      <Route
        path="/super-admin/dashboard/views"
        element={(
          <RequireAuth>
            <Views />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/live-videos"
        element={(
          <RequireAuth>
            <LiveVideos />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/office-hours"
        element={(
          <RequireAuth>
            <OfficeHours />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/live-videos-report/:video_id"
        element={(
          <RequireAuth>
            <LiveVideosReport />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/live-video-attendance-report"
        element={(
          <RequireAuth>
            <LiveVideoAttendanceReport />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/events"
        element={(
          <RequireAuth>
            <Events />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/teachers"
        element={(
          <RequireAuth>
            <Teachers />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/teachers-assistant"
        element={(
          <RequireAuth>
            <TeachersAssistant />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/chapters"
        element={(
          <RequireAuth>
            <Chapters />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/question-containers"
        element={(
          <RequireAuth>
            <QuestionContainers />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/lectures"
        element={(
          <RequireAuth>
            <Lectures />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/exams"
        element={(
          <RequireAuth>
            <Exams />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/payments"
        element={(
          <RequireAuth>
            <Payment />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/payment-subjects"
        element={(
          <RequireAuth>
            <PaymentSubject />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/homework"
        element={(
          <RequireAuth>
            <Homeworks />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/payment-list/:payment_id"
        element={(
          <RequireAuth>
            <StudentsPaymentList />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/student-exams"
        element={(
          <RequireAuth>
            <StudentExamsList />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/student_exams_main"
        element={(
          <RequireAuth>
            <StudentExamsMain />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/questions-bank"
        element={(
          <RequireAuth>
            <QuestionsBank />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/tag-missed-questions"
        element={(
          <RequireAuth>
            <TagMissedQuestions />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/tags"
        element={(
          <RequireAuth>
            <Tags />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/videos-more-view-requests"
        element={(
          <RequireAuth>
            <VideosMoreViewRequests />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/exam-redo-requests"
        element={(
          <RequireAuth>
            <RedoRequests />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/bulk-custom-message"
        element={(
          <RequireAuth>
            <BulkCustomMessage />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/saved-messages"
        element={(
          <RequireAuth>
            <SavedMessages />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/saved-messages-by-phone"
        element={(
          <RequireAuth>
            <SavedMessagesByPhone />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/announcements"
        element={(
          <RequireAuth>
            <Announcements />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/custom-notify-practice"
        element={(
          <RequireAuth>
            <CustomNotifyPractice />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/subject-assist-phones"
        element={(
          <RequireAuth>
            <SubjectAssistPhones />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/assistants"
        element={(
          <RequireAuth>
            <Assistants />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/student-payments"
        element={(
          <RequireAuth>
            <StudentPayments />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/downloaded-reports"
        element={(
          <RequireAuth>
            <DownloadableReport />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/attendence-report"
        element={(
          <RequireAuth>
            <AttendanceReport />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/attendence-simple-report"
        element={(
          <RequireAuth>
            <AttendanceSimpleReport />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/absent-report"
        element={(
          <RequireAuth>
            <AbsentReport />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/manual-exam-marks-report"
        element={(
          <RequireAuth>
            <ManualExamMarksReport />
          </RequireAuth>
        )}
      />

      <Route
        path="/dashboard/exam-attendence-report"
        element={(
          <RequireAuth>
            <ExamAttendanceReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/exam-report"
        element={(
          <RequireAuth>
            <ExamReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/detailed-exam-report"
        element={(
          <RequireAuth>
            <DetailedExamReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/uncomment-homework-report"
        element={(
          <RequireAuth>
            <HomeworkUncommentReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/correct-student-exams"
        element={(
          <RequireAuth>
            <CorrectStudentExams />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/homework-report-by-chapter"
        element={(
          <RequireAuth>
            <HomeworkReportByChapter />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/homework-attendence-report"
        element={(
          <RequireAuth>
            <HomeworkAttendanceReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/homework-absent-report"
        element={(
          <RequireAuth>
            <HomeworkAbsentReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/videos-report"
        element={(
          <RequireAuth>
            <VideoReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/videos-absent-report"
        element={(
          <RequireAuth>
            <VideoAbsenceReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/groups-report"
        element={(
          <RequireAuth>
            <GroupsReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/print-all-questions"
        element={(
          <RequireAuth>
            <PrintableQuestions />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/unpaid-report"
        element={(
          <RequireAuth>
            <UnpaiedReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/payment-report"
        element={(
          <RequireAuth>
            <PaymentReport />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/telegram-active-users"
        element={(
          <RequireAuth>
            <TelegramActiveUsers />
          </RequireAuth>
        )}
      />
      <Route
        path="/dashboard/telegram-inactive-users"
        element={(
          <RequireAuth>
            <TelegramInactiveUsers />
          </RequireAuth>
        )}
      />

      {/* students (protected) */}
      <Route
        path="/students/courses/:courseId"
        element={(
          <RequireAuth>
            <StudentCourseDetails />
          </RequireAuth>
        )}
      />
      <Route
        path="/students/courses"
        element={(
          <RequireAuth>
            <StudentCourses />
          </RequireAuth>
        )}
      />
      <Route
        path="/students/quick-links"
        element={(
          <RequireAuth>
            <StudentQuickLinks />
          </RequireAuth>
        )}
      />
      <Route
        path="/students/office-hours"
        element={(
          <RequireAuth>
            <StudentOfficeHoursPage />
          </RequireAuth>
        )}
      />
      <Route
        path="/students/performance-analytics"
        element={(
          <RequireAuth>
            <StudentPerformanceAnalytics />
          </RequireAuth>
        )}
      />
      <Route
        path="/students/exams"
        element={(
          <RequireAuth>
            <StudentExamsPage />
          </RequireAuth>
        )}
      />
      <Route
        path="/students"
        element={(
          <RequireAuth>
            <StudentHome />
          </RequireAuth>
        )}
      />
      <Route
        path="/model-answers/chapters"
        element={(
          <RequireAuth>
            <ModelAnswersChaptersList />
          </RequireAuth>
        )}
      />
      <Route
        path="/model-answer/:id"
        element={(
          <RequireAuth>
            <StudentModelAnswer />
          </RequireAuth>
        )}
      />
      <Route
        path="/homework/:id"
        element={(
          <RequireAuth>
            <StudentHomeWork />
          </RequireAuth>
        )}
      />

      <Route
        path="/scan-code/:id/:type"
        element={(
          <RequireAuth>
            <ScanCode />
          </RequireAuth>
        )}
      />
      <Route
        path="/exam/:id"
        element={(
          <RequireAuth>
            <ChapterExams />
          </RequireAuth>
        )}
      />
      <Route
        path="/student/exams"
        element={<Navigate to="/students/exams" replace />}
      />

      <Route
        path="/exam-guide/:id"
        element={(
          <RequireAuth>
            <ExameGuide />
          </RequireAuth>
        )}
      />

      <Route
        path="/student/exam-guide/:id"
        element={(
          <RequireAuth>
            <ExameGuide />
          </RequireAuth>
        )}
      />
      <Route
        path="/solve-exam/:id"
        element={(
          <RequireAuth>
            <SolveExam />
          </RequireAuth>
        )}
      />

      <Route
        path="/student/solve-exam/:id"
        element={(
          <RequireAuth>
            <SolveExam />
          </RequireAuth>
        )}
      />
      <Route
        path="/asquera-practice/video-preview/:id"
        element={(
          <RequireAuth>
            <VideoPreviewPage />
          </RequireAuth>
        )}
      />
      <Route
        path="/exam-result/:id"
        element={(
          <RequireAuth>
            <ExamResult />
          </RequireAuth>
        )}
      />
      <Route
        path="/questions"
        element={(
          <RequireAuth>
            <Questions />
          </RequireAuth>
        )}
      />
      <Route
        path="/video/qr-code/:video_id"
        element={(
          <RequireAuth>
            <QrCodeVideos />
          </RequireAuth>
        )}
      />
      <Route
        path="/asquera-practice"
        element={(
          <RequireAuth>
            <AsqueraPracticeExams />
          </RequireAuth>
        )}
      />
      <Route
        path="/asquera-solve/:id"
        element={(
          <RequireAuth>
            <AsqueraPracticeSolveExam />
          </RequireAuth>
        )}
      />

      <Route
        path="/study/:id"
        element={(
          <RequireAuth>
            <AsqueraPracticeSolveExam />
          </RequireAuth>
        )}
      />

      {/* fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;
